<template>
	<div class="elems">
		<template v-for="item in mode">
			<template v-if="item['type'] == 'gif'">
				<gif :mode="item"></gif>
			</template>
			<template v-else>
				<div class="elem" :style="getStyles(item)">
					<img :src="(item['im'] == '#userphoto#' ? currentImage['im'] : item['im'])" :style="getImgStyles(item)">
				</div>
			</template>
		</template>
	</div>		
</template>

<script>
	export default {
		name: 'elems',
		props: ['mode', 'rotateDeg', 'currentImage'],
		methods: {
			getStyles (item) {
				let s = {
					width: item['size'][0] + 'px',
					height: item['size'][1] + 'px',
					transform: 'translate3d('+ (item['pos'].join('px,') + 'px') +') rotateY('+ (0-this.rotateDeg) +'deg)',
				}
				return s;
			},
			getImgStyles (item) {
				let s = {};
				// style默认作用于img元素
				if (item['style']) {
					s = Object.assign(s, item['style']);
				}
				return s;
			}
		}
	}
</script>

<style lang="less" scoped>
	.elem {
		position: absolute;
		transform-style: preserve-3d;
		img {
			width: 100%;
		}
	}
</style>